import { useFDBodyColor } from '@facet-wealth/design';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

/** @deprecated -- we should only set the background using the hook exported by FD useFDBodyColor */
export default function useBackgroundColor(color) {
  const theme = useTheme();
  let surfaceColor = 'default';
  if (color === theme.palette.facet.lightGray) {
    surfaceColor = 'subtle';
  }
  useFDBodyColor(surfaceColor);
}
